/**
 * Instance partagée du client API Victor (côté app agent).
 * - En dev : pointe sur /v1 (proxy Vite vers http://localhost:3000)
 * - En prod : VITE_API_BASE_URL (ex. https://api.myvictor.fr)
 *
 * Access token (JWT) en mémoire (pas localStorage, règle d'or n°6).
 * Refresh dans cookie httpOnly géré par l'API.
 */
import { createVictorApi } from "@victor/api-client";

let accessToken: string | null = null;
let onUnauthorizedHandler: (() => void) | null = null;

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function getAccessToken(): string | null {
  return accessToken;
}

export function onUnauthorized(handler: () => void): void {
  onUnauthorizedHandler = handler;
}

const baseUrl = import.meta.env.VITE_API_BASE_URL ?? "";

export const api = createVictorApi({
  baseUrl,
  getAuthToken: () => accessToken,
  onUnauthorized: () => onUnauthorizedHandler?.(),
  onForbidden: (code) => {
    if (
      code === "tenant_suspended_payment" ||
      code === "tenant_suspended" ||
      code === "tenant_resilie"
    ) {
      sessionStorage.setItem("victor.blocked_code", code);
      if (window.location.pathname !== "/compte-bloque") {
        window.location.replace("/compte-bloque");
      }
    }
  },
});
